export default interface Office {
    id: number;
    name: string;
}

export const OfficeDefaultProps: Office = {
    id: 0,
    name: ''
}
